import React from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import CustomSelect from "components/Common/custom-select";
import TableContainer from "components/Common/TableContainer";
import { useFormik } from "formik";

const categoryOptions = [
  { label: "Developer", value: "Developer" },
  { label: "Admin", value: "Admin" },
  { label: "Staff", value: "Staff" },
];

const departmentOptions = [
  { label: "Dot Net Development", value: "Dot Net Development" },
  { label: "Production", value: "Production" },
  // Add more departments as needed
];

const data = [
  { empno: "1491", name: "PRABHAKARAN K", doj: "15.02.12", designation: "Senior Software Engineer", deptName: "Dot Net Development", diff: 26 },
  { empno: "3013", name: "PRAKASH S", doj: "30.07.21", designation: "Senior Software Engineer", deptName: "Dot Net Development", diff: 3 },
  { empno: "3225", name: "SUBASRI S", doj: "07.03.25", designation: "Software Engineer", deptName: "Dot Net Development", diff: 3 },
  { empno: "3201", name: "LIBIYA J", doj: "10.07.24", designation: "Developer", deptName: "Dot Net Development", diff: 3 },
];

const columns = [
  { Header: "S No", Cell: ({ row }) => data.length - row.index, className: "serial-no text-center", },
  { Header: "EmpNo", accessor: "empno" },
  { Header: "Name", accessor: "name" },
  { Header: "DOJ", accessor: "doj" },
  { Header: "Designation", accessor: "designation" },
  { Header: "DepartmentName", accessor: "deptName" },
  { Header: "Diff", accessor: "diff" },
];

const AttendanceReportLongAbsent = () => {
  const formik = useFormik({
    initialValues: { category: "", department: "" },
    onSubmit: (values) => { console.log("Form Values:", values); },
  });

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Attendance" breadcrumbItem="Long Absent" />

        <Card>
          <CardBody>
            <form onSubmit={formik.handleSubmit}>
              <Row className="gy-3">
                <Col xl={4} md={6}>
                  <Label>Category</Label>
                  <CustomSelect
                    name="category"
                    value={formik.values.category}
                    onChange={(val) => formik.setFieldValue("category", val)}
                    options={categoryOptions}
                    placeholder="Select"
                  />
                </Col>
                <Col xl={4} md={6}>
                  <Label>Department</Label>
                  <CustomSelect
                    name="department"
                    value={formik.values.department}
                    onChange={(val) => formik.setFieldValue("department", val)}
                    options={departmentOptions}
                    placeholder="Select"
                  />
                </Col>
                <Col xl={4} className="d-flex align-items-end justify-content-end flex-wrap gap-2">
                  <Button type="submit" className="btn button-search"><i className="fas fa-search me-1" /> Search</Button>
                  <Button type="button" className="btn button-print"><i className="fas fa-print me-1" /> Print</Button>
                  <Button type="button" className="btn button-export"><i className="fas fa-file-export me-1" /> Export</Button>
                </Col>
              </Row>
            </form>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            <div className="timesheet-summary hoursheet p-2 mb-0 d-flex align-items-center justify-content-between flex-wrap">
              <div><p className="mb-0"><strong>AES Technologies (India) Pvt. Ltd.- AES Office</strong></p></div>
              <div><p className="mb-0"><strong>26.05.25</strong></p></div>
            </div>
            <div className="p-2 mb-0 timesheet-summary hoursheet text-center table-bordered table-head"><p className="mb-0"><strong>Long Absent Report</strong></p></div>
            <TableContainer
              columns={columns}
              data={data}
              isGlobalFilter={false}
              customPageSize={10}
              tableSorter={false}
            />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default AttendanceReportLongAbsent;
